export  const conditionsOptions = ["Shell and Core","Fitted"];